export const ERROR_FLAG = Symbol('GUCCI_GUARD_FAIL_FLAG');
